import React, { useState, useEffect } from "react";
import classes from "./addeditaccomodations.module.scss";
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import {
  Button,
  FormControl,
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  Select,
  Box,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { EmployeeDetailView } from "../Search/EmployeeDetailView";
import { Icon, DatePicker, Checkbox } from "@genesis/ui-kit";
import NotificationView from "../../../../Shared/Notification/NotificationView";
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import { constants } from "../../../../Shared/Url/Constants";
import Cookie from "js-cookie";
import { isEmpty, isString } from "../../../../Shared/Utill/Utills";
import moment from "moment";
import add from "../../../../Resources/add.png";
import deleteimg from "../../../../Resources/delete.png";
import add_disable from "../../../../Resources/add_disable.png";
import delete_disable from "../../../../Resources/delete_disable.png";
import { Dialog, useToggle } from "@genesis/ui-kit";
import { toUpperCaseString } from "../../../../Shared/Utill/Utills";

const AddEditAccomodations = (props) => {
  const personDetails = useSelector((state) => state.person.personData);
  const personStaticDetails = useSelector(
    (state) => state.personStatic.personStaticData
  );
  const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);

  const token = Cookie.get("X_TKN");
  const urlDetails = useSelector((state) => state.url.urlData);
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const [approvedDate, setApprovedDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [reason, setReason] = useState(null);
  const [method, setMethod] = useState(null);
  const [comments, setComments] = useState(null);
  const [readOnlyView, setReadyOnly] = React.useState(true);
  const [ongoingActionCompleted, setOngoingActionCompleted] =
    React.useState(true);
  const location = useLocation();
  console.log(location.state);
  const [flag, setFlag] = React.useState(
    location.state !== null ? location.state.flag : "A"
  );
  const history = useNavigate();
  const [minShiftLength, setMinShiftLength] = React.useState("");
  const [minShiftCritical, setMinShiftCritical] = React.useState(false);
  const [maxShiftLength, setMaxShiftLength] = React.useState("");
  const [maxShiftCritical, setMaxShiftCritical] = React.useState(false);
  const [minHours, setMinHours] = React.useState("");
  const [minHoursCritical, setMinHoursCritical] = React.useState(false);
  const [maxHours, setMaxHours] = React.useState("");
  const [maxHoursCritical, setMaxHoursCritical] = React.useState(false);
  const [maxDay, setMaxDay] = React.useState("");
  const [maxDayCritical, setMaxDayCritical] = React.useState(false);
  const [maxNight, setMaxNight] = React.useState("");
  const [maxNightCritical, setMaxNightCritical] = React.useState(false);
  const [minTime, setMinTime] = React.useState("");
  const [minTimeCritical, setMinTimeCritical] = React.useState(false);
  const [maxConsec, setMaxConsec] = React.useState("");
  const [maxConsecCritical, setMaxConsecCritical] = React.useState(false);
  const [maxHrsPerDay, setMaxHrsPerDay] = React.useState(null);
  
  const [accomId, setAccomId] = React.useState(
    location.state !== null ? location.state.accomId : null
  );
  const [employeeID, setEmployeeID] = React.useState(
    location.state !== null ? location.state.employeeID : null
  );
  const [employeeDetails, setEmployeeDetails] = React.useState(
    location.state !== null ? location.state.details : null
  );
  const dialog = useToggle();
  const [isEditDateValid, setIsEditDateValid] = React.useState(false);
  const [createDate, setCreateDate] = useState(null);
  const [deleted, setDeleted] = useState(null);
  const [businessDate, setBusinessDate] = React.useState(moment());

  //Availability fields states
  const [sunFrom, setSunFrom] = useState(null);
  const [sunTo, setSunTo] = useState(null);
  const [sunDayOff, setSunDayOff] = useState(false);
  const [monFrom, setMonFrom] = useState(null);
  const [monTo, setMonTo] = useState(null);
  const [monDayOff, setMonDayOff] = useState(false);
  const [tueFrom, setTueFrom] = useState(null);
  const [tueTo, setTueTo] = useState(null);
  const [tueDayOff, setTueDayOff] = useState(false);
  const [wedFrom, setWedFrom] = useState(null);
  const [wedTo, setWedTo] = useState(null);
  const [wedDayOff, setWedDayOff] = useState(false);
  const [thuFrom, setThuFrom] = useState(null);
  const [thuTo, setThuTo] = useState(null);
  const [thuDayOff, setThuDayOff] = useState(false);
  const [friFrom, setFriFrom] = useState(null);
  const [friTo, setFriTo] = useState(null);
  const [friDayOff, setFriDayOff] = useState(false);
  const [satFrom, setSatFrom] = useState(null);
  const [satTo, setSatTo] = useState(null);
  const [satDayOff, setSatDayOff] = useState(false);

  const [isInformationOnly, setInformationOnly] = React.useState(false);
  const [isSRSValueChanged, setSRSValueChanges] = React.useState(false);
  const [isPageValueChanged, setPageValueChanges] = React.useState(null);
  const [isCancelReset, setCancelReset] = useState(false);
  const [isSRSFieldsValueChanged, setIsSRSFieldsValueChanged] = React.useState(false);

  // employee name states
  const [nameMinShiftLength, setNameMinShiftLength] = React.useState(null);
  const [nameMaxShiftLength, setNameMaxShiftLength] = React.useState(null);
  const [nameMinHours, setNameMinHours] = React.useState(null);
  const [nameMaxHours, setNameMaxHours] = React.useState(null);
  const [nameMaxDay, setNameMaxDay] = React.useState(null);
  const [nameMaxNight, setNameMaxNight] = React.useState(null);
  const [nameMinTime, setNameMinTime] = React.useState(null);
  const [nameMaxConsec, setNameMaxConsec] = React.useState(null);
  const [nameMaxHrsPerDay, setNameMaxHrsPerDay] = React.useState(null);

  //employee rule set for self schedule validation
  const [emplRuleSet, setEmplRuleSet] = React.useState(null);

  // max srs parameter
  const [srsMaxDaysWeek, setSrsMaxDaysWeek] = React.useState(null);
  const [srsMaxHrsWeek, setSrsMaxHrsWeek] = React.useState(null);
  const [srsMaxShftLen, setSrsMaxShftLen] = React.useState(null);
  
  //kronos status & message
  const [kronosStatus, setKronosStatus] = React.useState("error");
  const [kronosMessage, setKronosMessage] = React.useState("");

  // check srs button clicked state
  const [isSrsButtonClicked, setIsSrsButtonClicked] = React.useState(false);

  const [modifiedSRSStates, setModifiedSRSStates] = React.useState({
    minShiftLength : "",
    maxShiftLength : "",
    minHours : "",
    maxHours : "",
    maxDay : "",
    maxNight : "",
    minTime : "",
    maxConsec : "",
  });

  useEffect(() => {
    if (flag === "A") {
      makeEditable();
    } else {
      getDetails();
    }
    let colleagueDivNbr = employeeDetails.mydiv.split("-");
    console.log(colleagueDivNbr[0]);
    let dateData = {
      divNbr: colleagueDivNbr[0],
      appAbbr: "AVL",
      locNbr: employeeDetails.mystore,
      dptNbr: employeeDetails.mydept,
      myWorkSchedule: employeeDetails.workschedule,
      minified: 0,
      today: moment().format("YYYY-MM-DD"),
    };
    
    //alert("Checking if we can use these fields for this call " + JSON.stringify(employeeDetails))
    // get first available edit date
    axiosInstance
      .post(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_AVL_FIRST_EDIT_DATE}`,
        dateData,
        {
          headers: {
            "content-type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        let data = response.data[0].fscBow;
        setBusinessDate(data);
      })
      .catch((error) => {
        // catch error
      });
  }, []);

  useEffect(() => {
   // if(flag == "E" && isPageValueChanged == null && isEditDateValid && isSRSValueChanged || flag == "A" && isPageValueChanged == null && isSRSValueChanged){
   if( !readOnlyView && flag == "E" && isEditDateValid == true && isSRSValueChanged && isSrsButtonClicked && isSRSFieldsValueChanged || (flag == "A" && isSRSValueChanged && isSrsButtonClicked && isSRSFieldsValueChanged ) ){  
   setAlertOpen({
        open: true,
        severity: "warning",
        message: 'Click "Calculate SRS Values" before the accommodation can be saved',
      });
    }
  },[isSRSValueChanged, isSRSFieldsValueChanged]);

  const getDetails = (accomId1 = null, isFromAdd = false) => {
    let accom = accomId1 === null ? accomId : accomId1;
    let url = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ACCOM_GET_ADMIN_ACCOMODATIONS_BY_ID}/${accom}`;
    
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        console.log(res);
        // Set states for all fields
        setAllStatesAfterGet(res.data);
        if(isFromAdd){
        saveUpdateToKronos("A",res.data.accomId,res.data.createDate);
        } // Post success to this using create date

      })
      .catch((err) => {
        setAlertOpen({
          open: true,
          severity: "error",
          message: err.response.data.message,
        });
      });
  };

  const setAllStatesAfterGet = (data) => {
    // common states
    setApprovedDate(data.approvedDate);
    setStartDate(data.startDate);
    setEndDate(data.endDate);
    setReason(data.accomTypeId);
    setMethod(
      toUpperCaseString(data.accomMethod) === "SRS"
        ? toUpperCaseString(data.accomMethod)
        : data.accomMethod
    );
    setComments(data.detail);
    setCreateDate(data.createDate);
    setDeleted(data.deleted);

    // check if start date is greater than today
    if (moment(data.startDate).isAfter(moment(), "day")) {
      setIsEditDateValid(true);
    }

    // set accom state for srs
    if (toUpperCaseString(data.accomMethod) === "SRS") {
      setMinShiftLength(data.minShiftLen == null ? "" : data.minShiftLen);
      setMaxShiftLength(data.maxShiftLen == null ? "" : data.maxShiftLen);
      setMinHours(data.minHrsWk == null ? "" : data.minHrsWk);
      setMaxHours(data.maxHrsWk == null ? "" : data.maxHrsWk);
      setMaxDay(data.maxDaysWk == null ? "" : data.maxDaysWk);
      setMaxNight(data.maxPmWk == null ? "" : data.maxPmWk);
      setMinTime(data.maxConsecDaysWk == null ? "" : data.maxConsecDaysWk);
      setMaxConsec(data.maxConsecDaysWk ==null ? "" : data.maxConsecDaysWk);
      setMinTime(data.minTimeBtwnShifts == null ? "" : data.minTimeBtwnShifts);
      //Critical values filed set state
      setMaxShiftCritical(
        data.shiftLenMaxCrit != null &&
          (data.shiftLenMaxCrit.toUpperCase() == "Y" ? true : false)
      );
      setMinShiftCritical(
        data.shiftLenMinCrit != null &&
          (data.shiftLenMinCrit.toUpperCase() == "Y" ? true : false)
      );
      setMinHoursCritical(
        data.shrsWkMinCrit != null &&
          (data.shrsWkMinCrit.toUpperCase() == "Y" ? true : false)
      );
      setMaxHoursCritical(
        data.hrsWkMaxCrit != null &&
          (data.hrsWkMaxCrit.toUpperCase() == "Y" ? true : false)
      );
      setMaxDayCritical(
        data.daysWkMaxCrit != null &&
          (data.daysWkMaxCrit.toUpperCase() == "Y" ? true : false)
      );
      setMaxNightCritical(
        data.pmWkMaxCrit != null &&
          (data.pmWkMaxCrit.toUpperCase() == "Y" ? true : false)
      );
      setMinTimeCritical(
        data.minTimeBtwnShiftsCrit != null &&
          (data.minTimeBtwnShiftsCrit.toUpperCase() == "Y" ? true : false)
      );
      setMaxConsecCritical(
        data.daysWkConsecMaxCrit != null &&
          (data.daysWkConsecMaxCrit.toUpperCase() == "Y" ? true : false)
      );
      setInformationOnly(data.infoOnly.toUpperCase() == "Y" ? true : false)
    } else {
      setSunFrom(data.sunFrom);
      setSunTo(data.sunTo);
      setSunDayOff(
        data.sunFrom === "DAYOFF" || data.sunTo === "DAYOFF" ? true : false
      );
      setMonFrom(data.monFrom);
      setMonTo(data.monTo);
      setMonDayOff(
        data.monFrom === "DAYOFF" || data.monTo === "DAYOFF" ? true : false
      );
      setTueFrom(data.tueFrom);
      setTueTo(data.tueTo);
      setTueDayOff(
        data.tueFrom === "DAYOFF" || data.tueTo === "DAYOFF" ? true : false
      );
      setWedFrom(data.wedFrom);
      setWedTo(data.wedTo);
      setWedDayOff(
        data.wedFrom === "DAYOFF" || data.wedTo === "DAYOFF" ? true : false
      );
      setThuFrom(data.thuFrom);
      setThuTo(data.thuTo);
      setThuDayOff(
        data.thuFrom === "DAYOFF" || data.thuTo === "DAYOFF" ? true : false
      );
      setFriFrom(data.friFrom);
      setFriTo(data.friTo);
      setFriDayOff(
        data.friFrom === "DAYOFF" || data.friTo === "DAYOFF" ? true : false
      );
      setSatFrom(data.satFrom);
      setSatTo(data.satTo);
      setSatDayOff(
        data.satFrom === "DAYOFF" || data.satTo === "DAYOFF" ? true : false
      );
    }
    console.log("data", data);
    // handle kronos flags 
    //data.krProcessSw //
    //krLastUpdate // time
    //krRtnMsg //
    setKronosStatusStates(data.krProcessSw,data.krLastUpdate,data.krRtnMsg);
    
  };

  const addAccom = () => {
    setFlag("A");
    makeEditable();
    clearFields("SRS");
    clearFields("Availability");
    setMethod(null);
    setApprovedDate(null);
    setStartDate(null);
    setEndDate(null);
    setReason(null);
    setComments(null);
    setKronosStatus("error");
    setKronosMessage("");
    //Flag reset here
    setSRSValueChanges(false);
    setPageValueChanges(null);  
    setModifiedSRSStates({
        minShiftLength : "",
        maxShiftLength : "",
        minHours : "",
        maxHours : "",
        maxDay : "",
        maxNight : "",
        minTime : "",
        maxConsec : "",
      })   
    history("/accommodation/Addaccomodation");
  };

  const makeEditable = () => {
    setOngoingActionCompleted(false);
    console.log(readOnlyView + " ready only ");
    if (readOnlyView == true) {
      setReadyOnly(false);
    }
    // call get srs details with blank SRS fields
    if(flag === "E" && method === "SRS" && isInformationOnly === false){
      getSRSDetailsAPI("E", true)
    }
  };
  const makeReadOnly = () => {
    //on click of save
    setOngoingActionCompleted(true);
    if (readOnlyView == false) {
      setReadyOnly(true);
    }
  };

  const cancelEditing = () => {
    if (flag === "E") {
      setOngoingActionCompleted(true);
      setReadyOnly(true);
      getDetails();
      setSRSValueChanges(false);
      setPageValueChanges(null);  
      setModifiedSRSStates({
        minShiftLength : "",
        maxShiftLength : "",
        minHours : "",
        maxHours : "",
        maxDay : "",
        maxNight : "",
        minTime : "",
        maxConsec : "",
      })   
    } else {
      history("/accommodation");
    }
  };

  const setCritical = (event, method) => {
    method(event.target.checked);
  };

  const clearFields = (method) => {
    if (toUpperCaseString(method) === "SRS") {
      // clear availability fields
      EmptyAvailabilityStates();
    } else {
      // clear srs fields
      setMinShiftLength("");
      setMinShiftCritical(false);
      setMaxShiftLength("");
      setMaxShiftCritical(false);
      setMinHours("");
      setMinHoursCritical(false);
      setMaxHours("");
      setMaxHoursCritical(false);
      setMaxDay("");
      setMaxDayCritical(false);
      setMaxNight("");
      setMaxNightCritical(false);
      setMinTime("");
      setMinTimeCritical(false);
      setMaxConsec("");
      setMaxConsecCritical(false);
    }
  };

  const disableExceptSunday = (date) => {
    return (
      date.getDay() !== 0 || moment(date).isBefore(moment(businessDate), "day")
    );
  };

  const disableExceptSaturday = (date) => {
    //
    return (
      date.getDay() !== 6 ||
      moment(date).isBefore(moment().add("-7", "days"), "day")
    );
  };

  const saveData = () => {
    // validation for srs
    if (!ValidateAddEdit()) {
      return;
    }

    if (flag === "A") {
      // save data and call edit api
      let data = {
        ascNbr: employeeDetails.emplID,
        accomTypeId: reason,
        accomMethod: method,
        approvedDate:
          approvedDate !== null
            ? moment(approvedDate).format("YYYY/MM/DD")
            : null,
        startDate:
          startDate !== null ? moment(startDate).format("YYYY/MM/DD") : null,
        endDate: endDate !== null ? moment(endDate).format("YYYY/MM/DD") : null,
        detail: comments,
        sunFrom: sunDayOff ? "DAYOFF" : sunFrom,
        sunTo: sunDayOff ? "DAYOFF" : sunTo,
        monFrom: monDayOff ? "DAYOFF" : monFrom,
        monTo: monDayOff ? "DAYOFF" : monTo,
        tueFrom: tueDayOff ? "DAYOFF" : tueFrom,
        tueTo: tueDayOff ? "DAYOFF" : tueTo,
        wedFrom: wedDayOff ? "DAYOFF" : wedFrom,
        wedTo: wedDayOff ? "DAYOFF" : wedTo,
        thuFrom: thuDayOff ? "DAYOFF" : thuFrom,
        thuTo: thuDayOff ? "DAYOFF" : thuTo,
        friFrom: friDayOff ? "DAYOFF" : friFrom,
        friTo: friDayOff ? "DAYOFF" : friTo,
        satFrom: satDayOff ? "DAYOFF" : satFrom,
        satTo: satDayOff ? "DAYOFF" : satTo,
        minShiftLen:(isInformationOnly === true && minShiftCritical === true) || isInformationOnly === false ? minShiftLength : null,
        maxShiftLen: (isInformationOnly === true && maxShiftCritical === true) || isInformationOnly === false ? maxShiftLength : null,
        minHrsWk: (isInformationOnly === true && minHoursCritical === true) || isInformationOnly === false ? minHours : null,
        maxHrsWk: (isInformationOnly === true && maxHoursCritical === true) || isInformationOnly === false ? maxHours : null,
        maxDaysWk: (isInformationOnly === true && maxDayCritical === true) || isInformationOnly === false ? maxDay : null,
        maxPmWk: (isInformationOnly === true && maxNightCritical === true) || isInformationOnly === false ?  maxNight : null,
        maxConsecDaysWk:(isInformationOnly === true && maxConsecCritical === true) || isInformationOnly === false ?  maxConsec : null,
        minTimeBtwnShifts: (isInformationOnly === true && minTimeCritical === true) || isInformationOnly === false ?  minTime : null,
        unschedWkndDaysReq: null,
        unschedWkndDaysSpanWks: null,
        lastUpdatedBy: personStaticDetails.emplID,
        shiftLenMinCrit: minShiftCritical === true ? "y" : "n",
        shiftLenMaxCrit: maxShiftCritical === true ? "y" : "n",
        shrsWkMinCrit: minHoursCritical === true ? "y" : "n",
        hrsWkMaxCrit: maxHoursCritical === true ? "y" : "n",
        daysWkMaxCrit: maxDayCritical === true ? "y" : "n",
        pmWkMaxCrit: maxNightCritical === true ? "y" : "n",
        minTimeBtwnShiftsCrit: minTimeCritical === true ? "y" : "n",
        daysWkConsecMaxCrit: maxConsecCritical === true ? "y" : "n",
        infoOnly: isInformationOnly === true ? "y" : "n"
        
      };
      axiosInstance
        .post(
          `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ACCOM_ADD_WFM_ACCOMODATIONS}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          console.log(res);
          setAlertOpen({
            open: true,
            severity: "success",
            message:
              "Success! accommodation for " +
              employeeDetails.emplID +
              "," +
              employeeDetails.fullName +
              " has been added.",
          });
         
          makeReadOnly();
          setFlag("E");
          setAccomId(res.data.accomId);
          // call api to get details using accom id from response
          getDetails(res.data.accomId,true); // getting create_date
          //history("/accommodation/Edit");
          setSRSValueChanges(false);
          setPageValueChanges(false);
          setModifiedSRSStates({
            minShiftLength : "",
            maxShiftLength : "",
            minHours : "",
            maxHours : "",
            maxDay : "",
            maxNight : "",
            minTime : "",
            maxConsec : "",
          })
        })
        .catch((err) => {
          let message = err.response.data.message;
          setAlertOpen({
            open: true,
            severity: "error",
            message: message,
          });
        });
    } else if (flag === "E") {
      // save data and call edit api
      let data = {
        accomId: accomId,
        endDate: endDate !== null ? moment(endDate).format("YYYY/MM/DD") : null,
        detail: comments,
        lastUpdatedBy: personStaticDetails.emplID,
        ascNbr: employeeDetails.emplID,
        accomTypeId: reason,
        accomMethod: method,
        approvedDate:
          approvedDate !== null
            ? moment(approvedDate).format("YYYY/MM/DD")
            : null,
        startDate:
          startDate !== null ? moment(startDate).format("YYYY/MM/DD") : null,
        sunFrom: sunDayOff ? "DAYOFF" : sunFrom,
        sunTo: sunDayOff ? "DAYOFF" : sunTo,
        monFrom: monDayOff ? "DAYOFF" : monFrom,
        monTo: monDayOff ? "DAYOFF" : monTo,
        tueFrom: tueDayOff ? "DAYOFF" : tueFrom,
        tueTo: tueDayOff ? "DAYOFF" : tueTo,
        wedFrom: wedDayOff ? "DAYOFF" : wedFrom,
        wedTo: wedDayOff ? "DAYOFF" : wedTo,
        thuFrom: thuDayOff ? "DAYOFF" : thuFrom,
        thuTo: thuDayOff ? "DAYOFF" : thuTo,
        friFrom: friDayOff ? "DAYOFF" : friFrom,
        friTo: friDayOff ? "DAYOFF" : friTo,
        satFrom: satDayOff ? "DAYOFF" : satFrom,
        satTo: satDayOff ? "DAYOFF" : satTo,
        minShiftLen:(isInformationOnly === true && minShiftCritical === true) || isInformationOnly === false ? minShiftLength : null,
        maxShiftLen: (isInformationOnly === true && maxShiftCritical === true) || isInformationOnly === false ? maxShiftLength : null,
        minHrsWk: (isInformationOnly === true && minHoursCritical === true) || isInformationOnly === false ? minHours : null,
        maxHrsWk: (isInformationOnly === true && maxHoursCritical === true) || isInformationOnly === false ? maxHours : null,
        maxDaysWk: (isInformationOnly === true && maxDayCritical === true) || isInformationOnly === false ? maxDay : null,
        maxPmWk: (isInformationOnly === true && maxNightCritical === true) || isInformationOnly === false ?  maxNight : null,
        maxConsecDaysWk:(isInformationOnly === true && maxConsecCritical === true) || isInformationOnly === false ?  maxConsec : null,
        minTimeBtwnShifts: (isInformationOnly === true && minTimeCritical === true) || isInformationOnly === false ?  minTime : null,
        unschedWkndDaysReq: null,
        unschedWkndDaysSpanWks: null,
        createDate: createDate,
        deleted: deleted,
        shiftLenMinCrit: minShiftCritical === true ? "y" : "n",
        shiftLenMaxCrit: maxShiftCritical === true ? "y" : "n",
        shrsWkMinCrit: minHoursCritical === true ? "y" : "n",
        hrsWkMaxCrit: maxHoursCritical === true ? "y" : "n",
        daysWkMaxCrit: maxDayCritical === true ? "y" : "n",
        pmWkMaxCrit: maxNightCritical === true ? "y" : "n",
        minTimeBtwnShiftsCrit: minTimeCritical === true ? "y" : "n",
        daysWkConsecMaxCrit: maxConsecCritical === true ? "y" : "n",
        infoOnly: isInformationOnly === true ? "y" : "n"
      };
      console.log("data is", data);
      axiosInstance
        .post(
          `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ACCOM_ADD_EDIT_WFM_ACCOMODATIONS}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          console.log(res);
          //TODO: call save to kronos if method == SRS
          saveUpdateToKronos("E",accomId,createDate);
          setAlertOpen({
            open: true,
            severity: "success",
            message: "Accomodation updated successfully",
          });
          makeReadOnly();
          setSRSValueChanges(false);
          setPageValueChanges(false);
          setModifiedSRSStates({
            minShiftLength : "",
            maxShiftLength : "",
            minHours : "",
            maxHours : "",
            maxDay : "",
            maxNight : "",
            minTime : "",
            maxConsec : "",
          })
        })
        .catch((err) => {
          let message = err.response.data.message;
          setAlertOpen({
            open: true,
            severity: "error",
            message: message,
          });
        });
    }
  };
  const EmptyAvailabilityStates = () => {
    setSunFrom(null);
    setSunTo(null);
    setSunDayOff(false);
    setMonFrom(null);
    setMonTo(null);
    setMonDayOff(false);
    setTueFrom(null);
    setTueTo(null);
    setTueDayOff(false);
    setWedFrom(null);
    setWedTo(null);
    setWedDayOff(false);
    setThuFrom(null);
    setThuTo(null);
    setThuDayOff(false);
    setFriFrom(null);
    setFriTo(null);
    setFriDayOff(false);
    setSatFrom(null);
    setSatTo(null);
    setSatDayOff(false);
  };

  const ValidateAddEdit = () => {
    let isDataValid = true;
    let kremplRuleSet = emplRuleSet;

    if (isEmpty(approvedDate)) {
      isDataValid = false;
      showErrorMsg("Approved Date should not be empty");
    } else if (isEmpty(startDate)) {
      isDataValid = false;
      showErrorMsg("Start Date should not be empty");
    } else if (isEmpty(reason)) {
      isDataValid = false;
      showErrorMsg("Reason should not be empty");
    } else if (
      isString(minShiftLength) ||
      isString(maxShiftLength) ||
      isString(minHours) ||
      isString(maxHours) ||
      isString(maxDay) ||
      isString(maxNight) ||
      isString(minTime) ||
      isString(maxConsec)
    ) {
      isDataValid = false;
      showErrorMsg("All SRS parameter's values should be numeric");
    } else if (moment(endDate).isBefore(moment(startDate))) {
      isDataValid = false;
      showErrorMsg("End date should be after start date");
    } else if (toUpperCaseString(method) === "SRS") {
      // check if critical value has fields filled
      let isCriticalHasValue = true;
      if (minShiftCritical && isEmpty(minShiftLength)) {
        isCriticalHasValue = false;
      }
      if (maxShiftCritical && isEmpty(maxShiftLength)) {
        isCriticalHasValue = false;
      }
      if (minHoursCritical && isEmpty(minHours)) {
        isCriticalHasValue = false;
      }
      if (maxHoursCritical && isEmpty(maxHours)) {
        isCriticalHasValue = false;
      }
      if (maxDayCritical && isEmpty(maxDay)) {
        isCriticalHasValue = false;
      }
      //if (maxNightCritical && isEmpty(maxNight)) {
      if (maxNightCritical && (maxNight === "" || maxNight === null)) {
        isCriticalHasValue = false;
      }
      if (minTimeCritical && isEmpty(minTime)) {
        isCriticalHasValue = false;
      }
      if (maxConsecCritical && isEmpty(maxConsec)) {
        isCriticalHasValue = false;
      }

      //check if all parameters are blank
      if (
        (minShiftLength === "" || minShiftLength === null) &&
        (maxShiftLength === "" || maxShiftLength === null) &&
        (minHours === "" || minHours === null) &&
        (maxHours === "" || maxHours === null) &&
        (maxDay === "" || maxDay === null) &&
        (maxNight === "" || maxNight === null) &&
        (minTime === "" || minTime === null) &&
        (maxConsec === "" || maxConsec === null)
      ) {
        isDataValid = false;
        showErrorMsg("Please select atleast 1 SRS field");
      } else if (
        minShiftLength != "" &&
        minShiftLength !== null &&
        (minShiftLength % 0.25 !== 0 ||
          minShiftLength < 2 ||
          minShiftLength > 12)
      ) {
        isDataValid = false;
        if (minShiftLength % 0.25 !== 0) {
          showErrorMsg(
            "Please enter either .25 .50 or .75 for partial minimum shift length. Maximum length 12"
          );
        } else {
          showErrorMsg("Minimum Shift Length must be between 2 and 12");
        }
      } else if (
        maxShiftLength != "" &&
        maxShiftLength !== null &&
        (maxShiftLength % 0.25 !== 0 ||
          maxShiftLength < 2 ||
          maxShiftLength > 12)
      ) {
        isDataValid = false;
        if (maxShiftLength % 0.25 !== 0) {
          showErrorMsg(
            "Please enter either .25 .50 or .75 for partial maximum shift length. Maximum length 12"
          );
        } else {
          showErrorMsg("Maximum Shift Length must be between 2 and 12");
        }
      } else if (
        minHours != "" &&
        minHours !== null &&
        (minHours % 0.25 !== 0 || minHours < 2 || minHours > 168)
      ) {
        isDataValid = false;
        if (minHours % 0.25 !== 0) {
          showErrorMsg(
            "Please enter either .25 .50 or .75 for partial minimum hours per week. 168 hours maximum. "
          );
        } else {
          showErrorMsg("Minimum Hours per Week must be between 2 and 168");
        }
      } else if (
        maxHours != "" &&
        maxHours !== null &&
        (maxHours % 0.25 !== 0 || maxHours < 2 || maxHours > 168)
      ) {
        isDataValid = false;
        if (maxHours % 0.25 !== 0) {
          showErrorMsg(
            "Please enter either .25 .50 or .75 for partial maximum hours per week. 168 hours maximum. "
          );
        } else {
          showErrorMsg("Maximum Hours per Week must be between 2 and 168");
        }
      } else if (
        maxDay != "" &&
        maxDay !== null &&
        (maxDay < 1 || maxDay > 7)
      ) {
        isDataValid = false;
        showErrorMsg("Maximum Days per Week must be between 1 and 7 days");
      } else if (
        maxNight != "" &&
        maxNight !== null &&
        (maxNight < 0 || maxNight > 7)
      ) {
        isDataValid = false;
        showErrorMsg("Maximum Nights per Week must be between 0 and 7 nights");
      } else if (
        minTime != "" &&
        minTime !== null &&
        (minTime % 0.25 !== 0 || minTime < 1)
      ) {
        isDataValid = false;
        showErrorMsg("Minimum Time Between Shifts must be at least 1 hour.");
      } else if (maxConsec != "" && maxConsec !== null && maxConsec < 1) {
        isDataValid = false;
        showErrorMsg("Maximum Consecutive Days must be at least 1 day");
      } else if (!isCriticalHasValue) {
        isDataValid = false;
        showErrorMsg("Please type value for the selected critical value.");
      } else if(srsMaxDaysWeek !== null && (maxDay > srsMaxDaysWeek) && !kremplRuleSet.toLowerCase().includes('self scheduled')) {
        isDataValid = false;
        showErrorMsg(`Max Days per Week cannot be greater than ${srsMaxDaysWeek}`);
      } else if(srsMaxHrsWeek !== null && (maxHours > srsMaxHrsWeek) && !kremplRuleSet.toLowerCase().includes('self scheduled')) {
        isDataValid = false;        
        showErrorMsg(`Max Hours per Week cannot be greater than ${srsMaxHrsWeek}`);
      } else if(srsMaxShftLen !== null && (maxShiftLength > srsMaxShftLen) && !kremplRuleSet.toLowerCase().includes('self scheduled')) {
        isDataValid = false;
        showErrorMsg(`Max Shift length cannot be greater than ${srsMaxShftLen}`);
      } else if(minShiftLength != "" && minShiftLength !== null && maxShiftLength != "" && maxShiftLength !== null && (minShiftLength > maxShiftLength) && !kremplRuleSet.toLowerCase().includes('self scheduled')){
        isDataValid = false;
        showErrorMsg("Min Shift Length cannot be greater than Max Shift Length");
      } else if(minHours != "" && minHours !== null && maxHours != "" && maxHours !== null && (minHours > maxHours) && !kremplRuleSet.toLowerCase().includes('self scheduled')){
        isDataValid = false;
        showErrorMsg("Min Hours Per Week cannot be greater than Max Hrs per Week");
      } else if(maxNight != "" && maxNight !== null && maxDay != "" && maxDay !== null && (maxNight > maxDay)){
        isDataValid = false;
        showErrorMsg("Max Nights per Week must be equal to or less than max days per week");
      }
    } else if (method === "Availability") {
      if (
        sunFrom > sunTo ||
        (sunFrom !== null &&
          sunFrom != "DAYOFF" &&
          sunFrom.split(":")[1] % 15 != 0) ||
        (sunTo !== null && sunTo != "DAYOFF" && sunTo.split(":")[1] % 15 != 0)
      ) {
        isDataValid = false;
        if (sunFrom > sunTo)
          showErrorMsg("To time must be greater than From time");
        else if (
          (sunFrom !== null && sunFrom.split(":")[1] % 15 != 0) ||
          (sunTo !== null && sunTo.split(":")[1] % 15 != 0)
        )
          showErrorMsg("Time should be in 15 minute increments.");
      } else if (
        monFrom > monTo ||
        (monFrom !== null &&
          monFrom != "DAYOFF" &&
          monFrom.split(":")[1] % 15 != 0) ||
        (monTo !== null && monTo != "DAYOFF" && monTo.split(":")[1] % 15 != 0)
      ) {
        isDataValid = false;
        if (monFrom > monTo)
          showErrorMsg("To time must be greater than From time");
        else if (
          (monFrom !== null && monFrom.split(":")[1] % 15 != 0) ||
          (monTo !== null && monTo.split(":")[1] % 15 != 0)
        )
          showErrorMsg("Time should be in 15 minute increments.");
      } else if (
        tueFrom > tueTo ||
        (tueFrom !== null &&
          tueFrom != "DAYOFF" &&
          tueFrom.split(":")[1] % 15 != 0) ||
        (tueTo !== null && tueTo != "DAYOFF" && tueTo.split(":")[1] % 15 != 0)
      ) {
        isDataValid = false;
        if (tueFrom > tueTo)
          showErrorMsg("To time must be greater than From time3");
        else if (
          (tueFrom !== null && tueFrom.split(":")[1] % 15 != 0) ||
          (tueTo !== null && tueTo.split(":")[1] % 15 != 0)
        )
          showErrorMsg("Time should be in 15 minute increments.");
      } else if (
        wedFrom > wedTo ||
        (wedFrom !== null &&
          wedFrom != "DAYOFF" &&
          wedFrom.split(":")[1] % 15 != 0) ||
        (wedTo !== null && wedTo != "DAYOFF" && wedTo.split(":")[1] % 15 != 0)
      ) {
        isDataValid = false;
        if (wedFrom > wedTo)
          showErrorMsg("To time must be greater than From time");
        else if (
          (wedFrom !== null && wedFrom.split(":")[1] % 15 != 0) ||
          (wedTo !== null && wedTo.split(":")[1] % 15 != 0)
        )
          showErrorMsg("Time should be in 15 minute increments.");
      } else if (
        thuFrom > thuTo ||
        (thuFrom !== null &&
          thuFrom != "DAYOFF" &&
          thuFrom.split(":")[1] % 15 != 0) ||
        (thuTo !== null && thuTo != "DAYOFF" && thuTo.split(":")[1] % 15 != 0)
      ) {
        isDataValid = false;
        if (thuFrom > thuTo)
          showErrorMsg("To time must be greater than From time");
        else if (
          (thuFrom !== null && thuFrom.split(":")[1] % 15 != 0) ||
          (thuTo !== null && thuTo.split(":")[1] % 15 != 0)
        )
          showErrorMsg("Time should be in 15 minute increments.");
      } else if (
        friFrom > friTo ||
        (friFrom !== null &&
          friFrom != "DAYOFF" &&
          friFrom.split(":")[1] % 15 != 0) ||
        (friTo !== null && friTo != "DAYOFF" && friTo.split(":")[1] % 15 != 0)
      ) {
        isDataValid = false;
        if (friFrom > friTo)
          showErrorMsg("To time must be greater than From time");
        else if (
          (friFrom !== null && friFrom.split(":")[1] % 15 != 0) ||
          (friTo !== null && friTo.split(":")[1] % 15 != 0)
        )
          showErrorMsg("Time should be in 15 minute increments.");
      } else if (
        satFrom > satTo ||
        (satFrom !== null &&
          satFrom != "DAYOFF" &&
          satFrom.split(":")[1] % 15 != 0) ||
        (satTo !== null && satTo != "DAYOFF" && satTo.split(":")[1] % 15 != 0)
      ) {
        isDataValid = false;
        if (satFrom > satTo)
          showErrorMsg("To time must be greater than From time");
        else if (
          (satFrom !== null && satFrom.split(":")[1] % 15 != 0) ||
          (satTo !== null && satTo.split(":")[1] % 15 != 0)
        )
          showErrorMsg("Time should be in 15 minute increments.");
      }
    }

    return isDataValid;
  };
  
  const showErrorMsg = (msg) => {
    setAlertOpen({
      open: true,
      severity: "error",
      message: msg,
    });
  };
  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const setMethodType = (e) => {
    setMethod(e.target.value);
    if (flag == "A") {
      clearFields(e.target.value);
    }
    if(e.target.value === "SRS") {
      getSRSDetailsAPI("D")
    }
  };

  const SaveKronosStatusToGCP = (kronosProcSwitch,lastUpdateTime,KronosMessage,fromAOrE,accomID, createDate)=>{
     // save data and call edit api
     let data = {
      accomId: accomID,
      endDate: endDate !== null ? moment(endDate).format("YYYY/MM/DD") : null,
      detail: comments,
      lastUpdatedBy: personStaticDetails.emplID,
      ascNbr: employeeDetails.emplID,
      accomTypeId: reason,
      accomMethod: method,
      approvedDate:
        approvedDate !== null
          ? moment(approvedDate).format("YYYY/MM/DD")
          : null,
      startDate:
        startDate !== null ? moment(startDate).format("YYYY/MM/DD") : null,
      sunFrom: sunDayOff ? "DAYOFF" : sunFrom,
      sunTo: sunDayOff ? "DAYOFF" : sunTo,
      monFrom: monDayOff ? "DAYOFF" : monFrom,
      monTo: monDayOff ? "DAYOFF" : monTo,
      tueFrom: tueDayOff ? "DAYOFF" : tueFrom,
      tueTo: tueDayOff ? "DAYOFF" : tueTo,
      wedFrom: wedDayOff ? "DAYOFF" : wedFrom,
      wedTo: wedDayOff ? "DAYOFF" : wedTo,
      thuFrom: thuDayOff ? "DAYOFF" : thuFrom,
      thuTo: thuDayOff ? "DAYOFF" : thuTo,
      friFrom: friDayOff ? "DAYOFF" : friFrom,
      friTo: friDayOff ? "DAYOFF" : friTo,
      satFrom: satDayOff ? "DAYOFF" : satFrom,
      satTo: satDayOff ? "DAYOFF" : satTo,
      minShiftLen:(isInformationOnly === true && minShiftCritical === true) || isInformationOnly === false ? minShiftLength : null,
      maxShiftLen: (isInformationOnly === true && maxShiftCritical === true) || isInformationOnly === false ? maxShiftLength : null,
      minHrsWk: (isInformationOnly === true && minHoursCritical === true) || isInformationOnly === false ? minHours : null,
      maxHrsWk: (isInformationOnly === true && maxHoursCritical === true) || isInformationOnly === false ? maxHours : null,
      maxDaysWk: (isInformationOnly === true && maxDayCritical === true) || isInformationOnly === false ? maxDay : null,
      maxPmWk: (isInformationOnly === true && maxNightCritical === true) || isInformationOnly === false ?  maxNight : null,
      maxConsecDaysWk:(isInformationOnly === true && maxConsecCritical === true) || isInformationOnly === false ?  maxConsec : null,
      minTimeBtwnShifts: (isInformationOnly === true && minTimeCritical === true) || isInformationOnly === false ?  minTime : null,
      unschedWkndDaysReq: null,
      unschedWkndDaysSpanWks: null,
      createDate: createDate,
      deleted: deleted,
      shiftLenMinCrit: minShiftCritical === true ? "y" : "n",
      shiftLenMaxCrit: maxShiftCritical === true ? "y" : "n",
      shrsWkMinCrit: minHoursCritical === true ? "y" : "n",
      hrsWkMaxCrit: maxHoursCritical === true ? "y" : "n",
      daysWkMaxCrit: maxDayCritical === true ? "y" : "n",
      pmWkMaxCrit: maxNightCritical === true ? "y" : "n",
      minTimeBtwnShiftsCrit: minTimeCritical === true ? "y" : "n",
      daysWkConsecMaxCrit: maxConsecCritical === true ? "y" : "n",
      infoOnly: isInformationOnly === true ? "y" : "n",
      krProcessSw : kronosProcSwitch,
      krLastUpdate: lastUpdateTime,
      krRtnMsg: KronosMessage,
     
    };
    //nameMaxHrsPerDay: nameMaxHrsPerDay,
   // maxHrsPerDay: maxHrsPerDay,
    console.log("data is", data);
    axiosInstance
      .post(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ACCOM_ADD_EDIT_WFM_ACCOMODATIONS}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        //set State to display kronos staus after GCP update
        //kronosProcSwitch;
        //lastUpdateTime;
        //KronosMessage;
        
        setKronosStatusStates(kronosProcSwitch,lastUpdateTime,KronosMessage);

        
       
      })
      .catch((err) => {
        let message = err.response.data.message;
        setAlertOpen({
          open: true,
          severity: "error",
          message: message,
        });
      });

      if(fromAOrE == "A"){
        history("/accommodation/Edit");
      }
  }

  const setKronosStatusStates = (kronosProcSwitch,lastUpdateTime,KronosMessage)=> {
    let date =   (lastUpdateTime !== null
      ? moment(lastUpdateTime).format("MM/DD/YY , hh:mm A")
      : "")
   if(kronosProcSwitch == "Yes"){
     setKronosStatus("success");
     setKronosMessage("Saved successfully at " + date );
   }else if(kronosProcSwitch == "No"){
     setKronosStatus("error");
     let msg = isEmpty(date) ? "Error: Save to kronos failed." : ("Error : "+ KronosMessage +" at " + date);
     setKronosMessage(msg);
   }else{
     setKronosStatus("error");
     setKronosMessage("");
   }
  
  }
  function AddAvailabilityAccomComp(props) {
    return (
      <Grid container spacing={3} marginTop={"0px"} marginLeft={"0px"}>
        <Grid key={"label"} item xs={2}>
          <div className={classes.pagesubtitle}> Day Controls </div>
        </Grid>

        <Grid key={"Avlview"} item xs={10}>
          <Box>
            <Grid container spacing={2} rowSpacing={3}>
              <Grid key={0} item xs={1} marginTop={4}>
                <Typography variant="bodyMedium">Sunday</Typography>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="From"
                    value={sunFrom || ""}
                    onChange={(e) =>
                      setSunFrom(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      sunDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="To"
                    value={sunTo || ""}
                    onChange={(e) =>
                      setSunTo(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      sunDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={2} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => {
                      setSunDayOff(e.target.checked);
                      if (e.target.checked) {
                        setSunFrom(null);
                        setSunTo(null);
                      }
                    }}
                    control={
                      <Checkbox
                        checked={sunDayOff}
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                      />
                    }
                    label="Day Off"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* Monday */}
            <Grid container spacing={2} rowSpacing={3}>
              <Grid key={0} item xs={1} marginTop={4}>
                <Typography variant="bodyMedium">Monday</Typography>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="From"
                    value={monFrom || ""}
                    onChange={(e) =>
                      setMonFrom(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      monDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="To"
                    value={monTo || ""}
                    onChange={(e) =>
                      setMonTo(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      monDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={2} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => {
                      setMonDayOff(e.target.checked);
                      if (e.target.checked) {
                        setMonFrom(null);
                        setMonTo(null);
                      }
                    }}
                    control={
                      <Checkbox
                        checked={monDayOff}
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                      />
                    }
                    label="Day Off"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* Tuesday */}
            <Grid container spacing={2} rowSpacing={3}>
              <Grid key={0} item xs={1} marginTop={4}>
                <Typography variant="bodyMedium">Tuesday</Typography>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="From"
                    value={tueFrom || ""}
                    onChange={(e) =>
                      setTueFrom(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      tueDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="To"
                    value={tueTo || ""}
                    onChange={(e) =>
                      setTueTo(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      tueDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={2} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => {
                      setTueDayOff(e.target.checked);
                      if (e.target.value) {
                        setTueFrom(null);
                        setTueTo(null);
                      }
                    }}
                    control={
                      <Checkbox
                        checked={tueDayOff}
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                      />
                    }
                    label="Day Off"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* Wednesday */}
            <Grid container spacing={2} rowSpacing={3}>
              <Grid key={0} item xs={1} marginTop={4}>
                <Typography variant="bodyMedium">Wednesday</Typography>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="From"
                    value={wedFrom || ""}
                    onChange={(e) =>
                      setWedFrom(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      wedDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="To"
                    value={wedTo || ""}
                    onChange={(e) =>
                      setWedTo(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      wedDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={2} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => {
                      setWedDayOff(e.target.checked);
                      if (e.target.value) {
                        setWedFrom(null);
                        setWedTo(null);
                      }
                    }}
                    control={
                      <Checkbox
                        checked={wedDayOff}
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                      />
                    }
                    label="Day Off"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* Thursday */}
            <Grid container spacing={2} rowSpacing={3}>
              <Grid key={0} item xs={1} marginTop={4}>
                <Typography variant="bodyMedium">Thursday</Typography>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="From"
                    value={thuFrom || ""}
                    onChange={(e) =>
                      setThuFrom(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      thuDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="To"
                    value={thuTo || ""}
                    onChange={(e) =>
                      setThuTo(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      thuDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={2} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => {
                      setThuDayOff(e.target.checked);
                      if (e.target.value) {
                        setThuFrom(null);
                        setThuTo(null);
                      }
                    }}
                    control={
                      <Checkbox
                        checked={thuDayOff}
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                      />
                    }
                    label="Day Off"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* Friday */}
            <Grid container spacing={2} rowSpacing={3}>
              <Grid key={0} item xs={1} marginTop={4}>
                <Typography variant="bodyMedium">Friday</Typography>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="From"
                    value={friFrom || ""}
                    onChange={(e) =>
                      setFriFrom(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      friDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="To"
                    value={friTo || ""}
                    onChange={(e) =>
                      setFriTo(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      friDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={2} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => {
                      setFriDayOff(e.target.checked);
                      if (e.target.value) {
                        setFriFrom(null);
                        setFriTo(null);
                      }
                    }}
                    control={
                      <Checkbox
                        checked={friDayOff}
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                      />
                    }
                    label="Day Off"
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* Saturday */}
            <Grid container spacing={2} rowSpacing={3}>
              <Grid key={0} item xs={1} marginTop={4}>
                <Typography variant="bodyMedium">Saturday</Typography>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="From"
                    value={satFrom || ""}
                    onChange={(e) =>
                      setSatFrom(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      satDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    sx={{ minWidth: "100%" }}
                    label="To"
                    value={satTo || ""}
                    onChange={(e) =>
                      setSatTo(e.target.value === "" ? null : e.target.value)
                    }
                    disabled={
                      readOnlyView ||
                      satDayOff ||
                      (flag == "E" && isEditDateValid == false)
                    }
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={2} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => {
                      setSatDayOff(e.target.checked);
                      if (e.target.value) {
                        setSatFrom(null);
                        setSatTo(null);
                      }
                    }}
                    control={
                      <Checkbox
                        checked={satDayOff}
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                      />
                    }
                    label="Day Off"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    );
  }

  const onButtonClick = () => {
    dialog.show();
  };

  const deleteAccomodation = () => {
    let data = {
      accomId: accomId,
      lastUpdatedBy: personStaticDetails.emplID,
    };
    axios
      .post(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ACCOM_ADMIN_DELETE_WFM_ACCOMODATIONS}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        dialog.hide();
        history("/accommodation", {
          state: {
            deleteAccomodation: `DeleteAccommodation`,
            empId: employeeDetails.emplID,
          },
        });
      })
      .catch((err) => {
        if (err.message === "Network Error") {
          history("/somethingwentwrong", {
            state: `Please logout and try again `,
          });
        } else {
          setAlertOpen({
            open: true,
            severity: "error",
            message: err.response.data.message,
          });
          dialog.hide();
        }
      });
  };

  // get SRS details
  const getSRSDetails = () => {
    //TODO: reset SRS mapping override flag
    //setSRSValueChanges(false);
    //TODO: perform GetSRS Details activities
    //TODO: validations
    if (getSRSButtonValidations()) {
      setIsSrsButtonClicked(true);
      setIsSRSFieldsValueChanged(false)
      // call get srs details api
      getSRSDetailsAPI(flag);
    }
  };

// const IsSRSDisable = () => {
//     return (
//       !isSRSValueChanged ||
//       !(
//         (!isEmpty(minShiftLength) && !isEmpty(maxShiftLength)
//         && !isEmpty(minHours) && !isEmpty(maxHours) && !isEmpty(maxNight)
//         && !isEmpty(minTime) && !isEmpty(maxConsec)) && 
//         (minShiftCritical ||
//         maxShiftCritical ||
//         minHoursCritical ||
//         maxHoursCritical ||
//         maxDayCritical ||
//         maxNightCritical ||
//         minTimeCritical ||
//         maxConsecCritical
//       ))
//     );
//   }

  const getSRSDetailsAPI = (action, mode = false) => {
    let colleagueDivNbr = employeeDetails.mydiv.split('-')
    let data = {
      "ascnbr": employeeDetails.emplID,
      "divnbr": colleagueDivNbr[0],
      "locnbr": employeeDetails.mystore,
      "schedArea": employeeDetails.mydept,
      "workschedule": employeeDetails.workschedule,
      "min_shft_len": mode === true || !minShiftCritical ? null : +minShiftLength,
      "max_shft_len": mode === true || !maxShiftCritical ? null : +maxShiftLength,
      "min_hrs_wk": mode === true || !minHoursCritical ? null : +minHours,
      "max_hrs_wk": mode === true || !maxHoursCritical ? null : +maxHours,
      "max_days_wk": mode === true || !maxDayCritical ? null : +maxDay,
      "max_pm_wk": mode === true || !maxNightCritical ? null : +maxNight,
      "max_consec_days_wk": mode === true || !maxConsecCritical ? null : +maxConsec,
      "min_time_btwn_shft": mode === true || !minTimeCritical ? null : +minTime,
      "action": action,
      "name_min_shft_len": mode === true ? null : nameMinShiftLength,
      "name_max_shft_len": mode === true ? null : nameMaxShiftLength,
      "name_min_hrs_wk": mode === true ? null : nameMinHours,
      "name_max_hrs_wk": mode === true ? null : nameMaxHours,
      "name_max_days_wk": mode === true ? null : nameMaxDay,
      "name_max_pm_wk": mode === true ? null : nameMaxNight,
      "name_max_consec_days_wk": mode === true ? null : nameMaxConsec,
      "name_time_btwn_shft": mode === true ? null : nameMinTime,
      "nameMaxHrsPerDay": nameMaxHrsPerDay,
      "maxHrsPerDay": maxHrsPerDay,
      "effectiveDate": startDate !== null ? moment(startDate).format("MM/DD/YYYY") : null,
      "emplruleset": mode === true ? null : emplRuleSet
  }

   axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_WFMCOMMON_BASE_URL}${constants.WFM_COMMON_GET_SRS_DETAILS}`, 
   data,
    {
      headers:{
      'Content-Type': 'application/json',
      'Authorization':'Bearer ' + token,
      }
    }).then((res) => {
     // set the 8 field values to null
     setMinShiftLength("");
     setMaxShiftLength("");
     setMinHours("");
     setMaxHours("");
     setMaxDay("");
     setMaxNight("");
     setMinTime("");
     setMaxConsec("");
     setMaxHrsPerDay(""); 

     //set employee rule set to null
     setEmplRuleSet("");

     console.log("response123",res)     
     setMinShiftLength(res.data.min_shft_len);
     setMaxShiftLength(res.data.max_shft_len);
     setMinHours(res.data.min_hrs_wk);
     setMaxHours(res.data.max_hrs_wk);
     setMaxDay(res.data.max_days_wk);
     setMaxNight(res.data.max_pm_wk);
     setMinTime(res.data.min_time_btwn_shft);
     setMaxConsec(res.data.max_consec_days_wk);
     setMaxHrsPerDay(res.data.maxHrsPerDay);

     //set name response
     setNameMinShiftLength(res.data.name_min_shft_len);
     setNameMaxShiftLength(res.data.name_max_shft_len);
     setNameMinHours(res.data.name_min_hrs_wk);
     setNameMaxHours(res.data.name_max_hrs_wk);
     setNameMaxDay(res.data.name_max_days_wk);
     setNameMaxNight(res.data.name_max_pm_wk);
     setNameMaxConsec(res.data.name_max_consec_days_wk);
     setNameMinTime(res.data.name_time_btwn_shft);
     setNameMaxHrsPerDay(res.data.nameMaxHrsPerDay);    
     
     // set max responses
     setSrsMaxDaysWeek(res.data.srs_max_days_week);
     setSrsMaxHrsWeek(res.data.srs_max_hrs_week);
     setSrsMaxShftLen(res.data.srs_max_shft_len);
     
     //set employee rule set
     setEmplRuleSet(res.data.emplruleset);


     //TODO: reset SRS mapping override flag
     setSRSValueChanges(false);
     if(flag == "E"){
     setPageValueChanges(false);
    }
    setModifiedSRSStates({
      minShiftLength : "",
      maxShiftLength : "",
      minHours : "",
      maxHours : "",
      maxDay : "",
      maxNight : "",
      minTime : "",
      maxConsec : "",
    })
  }).catch((err) => {
      // catch error
      showErrorMsg(err.response.data.details);
      //setSRSValueChanges(false);
      //setPageValueChanges(false);
    });
   }


  const getSRSButtonValidations = () => {
    //Step1: check atleast one parameter and critical value should be thr
    //Step2: checked critical values should not have empty or null input box value.

    let isCriticalHasValue = true;
    let kremplRuleSet = emplRuleSet;

    if (minShiftCritical && isEmpty(minShiftLength)) {
      isCriticalHasValue = false;
    }

    if (maxShiftCritical && isEmpty(maxShiftLength)) {
      isCriticalHasValue = false;
    }

    if (minHoursCritical && isEmpty(minHours)) {
      isCriticalHasValue = false;
    }

    if (maxHoursCritical && isEmpty(maxHours)) {
      isCriticalHasValue = false;
    }

    if (maxDayCritical && isEmpty(maxDay)) {
      isCriticalHasValue = false;
    }

    //if (maxNightCritical && isEmpty(maxNight)) {
      if (maxNightCritical && (maxNight === "" || maxNight === null)) {
      isCriticalHasValue = false;
    }

    if (minTimeCritical && isEmpty(minTime)) {
      isCriticalHasValue = false;
    }

    if (maxConsecCritical && isEmpty(maxConsec)) {
      isCriticalHasValue = false;
    }

    if (!isCriticalHasValue) {
      showErrorMsg("Please type value for the selected critical value.");
      return;
    }

    // min one value and critical value should be selected.

    if (
      isString(minShiftLength) ||
      isString(maxShiftLength) ||
      isString(minHours) ||
      isString(maxHours) ||
      isString(maxDay) ||
      isString(maxNight) ||
      isString(minTime) ||
      isString(maxConsec)
    ) {
      showErrorMsg("All SRS parameter's values should be numeric");
    }

    // validation for .25

    if (
      minShiftLength != "" &&
      minShiftLength !== null &&
      minShiftCritical &&
      (minShiftLength % 0.25 !== 0 ||
        minShiftLength < 2 ||
        minShiftLength > 12)
    ) {
      isCriticalHasValue = false;
      if (minShiftLength % 0.25 !== 0) {
        showErrorMsg(
          "Please enter either .25 .50 or .75 for partial minimum shift length. Maximum length 12"
        );
      } else {
        showErrorMsg("Minimum Shift Length must be between 2 and 12");
      }
    } else if (
      maxShiftLength != "" &&
      maxShiftLength !== null &&
      maxShiftCritical &&
      (maxShiftLength % 0.25 !== 0 ||
        maxShiftLength < 2 ||
        maxShiftLength > 12)
    ) {
      isCriticalHasValue = false;
      if (maxShiftLength % 0.25 !== 0) {
        showErrorMsg(
          "Please enter either .25 .50 or .75 for partial maximum shift length. Maximum length 12"
        );
      } else {
        showErrorMsg("Maximum Shift Length must be between 2 and 12");
      }
    } else if (
      minHours != "" &&
      minHours !== null &&
      minHoursCritical &&
      (minHours % 0.25 !== 0 || minHours < 2 || minHours > 168)
    ) {
      isCriticalHasValue = false;
      if (minHours % 0.25 !== 0) {
        showErrorMsg(
          "Please enter either .25 .50 or .75 for partial minimum hours per week. 168 hours maximum. "
        );
      } else {
        showErrorMsg("Minimum Hours per Week must be between 2 and 168");
      }
    } else if (
      maxHours != "" &&
      maxHours !== null &&
      maxHoursCritical &&
      (maxHours % 0.25 !== 0 || maxHours < 2 || maxHours > 168)
    ) {
      isCriticalHasValue = false;
      if (maxHours % 0.25 !== 0) {
        showErrorMsg(
          "Please enter either .25 .50 or .75 for partial maximum hours per week. 168 hours maximum. "
        );
      } else {
        showErrorMsg("Maximum Hours per Week must be between 2 and 168");
      }
    } else if (
      maxDay != "" &&
      maxDay !== null &&
      maxDayCritical &&
      (maxDay < 1 || maxDay > 7)
    ) {
      isCriticalHasValue = false;
      showErrorMsg("Maximum Days per Week must be between 1 and 7 days");
    } else if (
      maxNight != "" &&
      maxNight !== null &&
      maxNightCritical &&
      (maxNight < 0 || maxNight > 7)
    ) {
      isCriticalHasValue = false;
      showErrorMsg("Maximum Nights per Week must be between 0 and 7 nights");
    } else if (
      minTime != "" &&
      minTime !== null &&
      minTimeCritical &&
      (minTime % 0.25 !== 0 || minTime < 1)
    ) {
      isCriticalHasValue = false;
      showErrorMsg("Minimum Time Between Shifts must be at least 1 hour.");
    } else if (maxConsec != "" && maxConsec !== null && maxConsecCritical && maxConsec < 1) {
      isCriticalHasValue = false;
      showErrorMsg("Maximum Consecutive Days must be at least 1 day");
    } 
    
    // validation for max srs greater
    if(srsMaxDaysWeek !== null && maxDayCritical && (maxDay > srsMaxDaysWeek) &&  !kremplRuleSet.toLowerCase().includes('self scheduled')) {
      isCriticalHasValue = false;
      showErrorMsg(`Max Days per Week cannot be greater than ${srsMaxDaysWeek}`);
    }
    if(srsMaxHrsWeek !== null && maxHoursCritical && (maxHours > srsMaxHrsWeek) && !kremplRuleSet.toLowerCase().includes('self scheduled')) {
      isCriticalHasValue = false;
      showErrorMsg(`Max Hours per Week cannot be greater than ${srsMaxHrsWeek}`);
    }
    if(srsMaxShftLen !== null && maxShiftCritical && (maxShiftLength > srsMaxShftLen) && !kremplRuleSet.toLowerCase().includes('self scheduled')) {
      isCriticalHasValue = false;
      showErrorMsg(`Max Shift length cannot be greater than ${srsMaxShftLen}`);
    }


    return isCriticalHasValue;
  };

  const validateAllSRSFiledsEmpty = (disableSRSBtn) => {
    if (
      isEmpty(minShiftLength) &&
      isEmpty(maxShiftLength) &&
      isEmpty(minHours) &&
      isEmpty(maxHours) &&
      isEmpty(maxNight) &&
      isEmpty(minTime) &&
      isEmpty(maxConsec)
    ) {
      showErrorMsg(
        "Please enter at least one parameter and critical value to get SRS details."
      );
    } 
  };

  // sav/updatee to kronos
  const saveUpdateToKronos = (fromAOrE,accomID, createDate) => {
    if (toUpperCaseString(method) != "SRS") {
      return;
    }

    if (isInformationOnly) {
      return;
    }

    let data = {
      emplID: employeeDetails.emplID,
      expirationDate:
        endDate !== null ? moment(endDate).format("MM/DD/YYYY") : "01/01/3000",
      effectiveDate:
        startDate !== null ? moment(startDate).format("MM/DD/YYYY") : null,
      action : nameMinShiftLength !== null ? "E" : "A",
      minShiftLength: minShiftLength,
      nameMinShiftLength: nameMinShiftLength,
      maxShiftLength: maxShiftLength,
      nameMaxShiftLength: nameMaxShiftLength,
      minHrsPerWeek: minHours,
      nameMinHrsPerWeek: nameMinHours,
      maxHrsPerWeek: maxHours,
      nameMaxHrsPerWeek: nameMaxHours,
      maxDaysPerWeek: maxDay,
      nameMaxDaysPerWeek: nameMaxDay,
      maxNightsPerWeek: maxNight,
      nameMaxNightsPerWeek: nameMaxNight,
      maxConsecDaysPerWeek: maxConsec,
      nameMaxConsecDaysPerWeek: nameMaxConsec,
      minTimeBetweenShifts: minTime,
      nameMinTimeBetweenShifts: nameMinTime,
      maxHrsPerDay: maxHrsPerDay,
      nameMaxHrsPerDay: nameMaxHrsPerDay,
      emplRuleSet: emplRuleSet,
    };
    console.log("Kronos data is", data);
    axiosInstance
      .post(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_WFMCOMMON_BASE_URL}${constants.WFM_ACCOM_SAVE_UPDATED_TO_KRONOS}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        let krProcessSw = res.data.kr_process_sw;
        let krLastUpdate = res.data.kr_last_update;

        let krRtmMessage = (krProcessSw == "Yes") ? "Saved successfully" : res.data.kr_rtn_msg; 
       
        SaveKronosStatusToGCP(krProcessSw,krLastUpdate,krRtmMessage,fromAOrE,accomID, createDate);  

        makeReadOnly();
      })
      .catch((err) => {
        let krProcessSw = "No";
        let krLastUpdate = null;
        let krRtmMessage = "Save to kronos failed"; //err.response.data.message;
        SaveKronosStatusToGCP(krProcessSw,krLastUpdate,krRtmMessage,fromAOrE,accomID, createDate); 

      });
  };

  const getSaveDisableStatus = () => {
   // return false;
    if((flag == "E" && isEditDateValid == false)){
      //TODO://edit mode and accom has already started
      return false; 
    }else if(isEditDateValid == true && isSRSValueChanged){
      return false;
    }else if(isEditDateValid == true && !isSRSValueChanged){
      return true;
    }else{
      return false;
    }
    //return (isSRSValueChanged && isEditDateValid == true) || !(flag == "E" && isEditDateValid == false)
  }
  return (
    <div className={classes.multilang} >    
      <div style={{ width: "100%" }}>
        <Dialog
          open={dialog.open}
          title="Confirm Delete"
          onClose={dialog.hide}
          actions={
            <>
              <Button color="secondary" onClick={dialog.hide}>
                No
              </Button>
              <Button onClick={deleteAccomodation}>Yes</Button>
            </>
          }
        >
          {toUpperCaseString(method) === "SRS" ?
          <Typography>
          Deleting this accommodation will only remove from tracker, manual actions will need to be taken to remove from Kronos. Are you sure you want to delete this accommodation?
        </Typography> :
          <Typography>
            Are you sure you want to delete this accommodation?
          </Typography>
          }
        </Dialog>
        {
          flag === "A" &&
          <div
          className={classes.pagetitle}
          style={{ textAlign: "left", width: "55%", display: "inline-block" }}
          
        >
          Add Accommodation
        </div>
        }
        { flag === "E" &&
          <div
          className={classes.pagetitle}
          style={{ textAlign: "left", width: "55%", display: "inline-block" }}
          translate="no"
        >
          { employeeDetails.fullName }
          <span style={{fontSize:"36px"}} translate="yes">&nbsp;
          {startDate !== null
                ? moment(startDate).format("MMM DD, YYYY")
                : ""}
          </span>
              
        </div>
        }
        
        {flag === "E" && (
          <>
            <div
              className={classes.pagetitle}
              style={{
                textAlign: "right",
                width: "40%",
                display: "inline-block",
              }}
            >
              <div className={classes.eventicon2}>
                <img
                  className="images"
                  src={ongoingActionCompleted ? add : add_disable}
                />
                <div
                  style={{
                    pointerEvents: ongoingActionCompleted ? "auto" : "none",
                    color: ongoingActionCompleted ? "inherit" : "grey",
                    display: "inline-block",
                    marginLeft: "5px",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={ongoingActionCompleted ? addAccom : undefined}
                >
                  {" "}
                  Add{" "}
                </div>
              </div>
              <div className={classes.eventicon2}>
                {" "}
                <img
                  className="images"
                  src={ongoingActionCompleted ? deleteimg : delete_disable}
                />
                <span
                  style={{
                    pointerEvents: ongoingActionCompleted ? "auto" : "none",
                    color: ongoingActionCompleted ? "inherit" : "grey",
                    marginLeft: "5px",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={ongoingActionCompleted ? onButtonClick : undefined}
                >
                  Delete
                </span>
              </div>
            </div>
          </>
        )}
      </div>

      <div>
        {readOnlyView && (
          <NotificationView
            message={
              "This is a 'Read-only' page. To make changes, click 'Edit' below."
            }
            severity="info"
            specify="infoEditParent"
            width="40%"
            margin="5px"
          />
        )}

        <SnackBar
          open={open}
          message={message}
          severity={severity}
          onClose={handleAlertNotifClose}
        ></SnackBar>

        <Grid container spacing={3}>
          <Grid key={"detail"} item xs={2}>
            <div className={classes.pagesubtitle}> Details </div>
          </Grid>

          <Grid key={"detailView"} item xs={10}>
            <EmployeeDetailView margin="-12px" details={employeeDetails} />
          </Grid>

          <Grid key={0} item xs={2} marginTop={1}></Grid>
          <Grid key={1} item xs={2} marginTop={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <DatePicker
                label="Approved*"
                renderInput={(params) => <TextField {...params} />}
                inputFormat="MMM dd, yyyy"
                value={approvedDate}
                onChange={(newValue) => {
                  setApprovedDate(newValue);
                }}
                disabled={
                  readOnlyView || (flag == "E" && isEditDateValid == false)
                }
              />
            </FormControl>
          </Grid>
          <Grid key={2} item xs={2} marginTop={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <DatePicker
                label="Start Date*"
                renderInput={(params) => <TextField {...params} />}
                inputFormat="MMM dd, yyyy"
                value={startDate}
                onChange={(newValue) => {
                  setStartDate(newValue);
                }}
                disabled={
                  readOnlyView || (flag == "E" && isEditDateValid == false)
                }
                shouldDisableDate={disableExceptSunday}
              />
            </FormControl>
          </Grid>
          <Grid key={3} item xs={2} marginTop={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <DatePicker
                label="End Date"
                renderInput={(params) => <TextField {...params} />}
                inputFormat="MMM dd, yyyy"
                value={endDate}
                onChange={(newValue) => {
                  setEndDate(newValue);
                }}
                disabled={readOnlyView}
                shouldDisableDate={disableExceptSaturday}
              />
            </FormControl>
          </Grid>
          <Grid key={3} item xs={1.7} marginTop={2}>
            <FormControl style={{ minWidth: "100%" }}>
              {flag === "A" && (
                <InputLabel id="demo-select-basic-label">Reason * </InputLabel>
              )}
              <Select
                labelId="demo-select-basic-label"
                id="demo-select-basic"
                label="Dropdown Label"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                disabled={
                  readOnlyView || (flag == "E" && isEditDateValid == false)
                }
                defaultValue={reason}
              >
                <MenuItem value="1">Medical</MenuItem>
                <MenuItem value="2">Religious</MenuItem>
                <MenuItem value="3">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid key={3} item xs={2.2} marginTop={2}>
            <FormControl style={{ minWidth: "100%" }}>
              {flag === "A" && (
                <InputLabel id="demo-select-basic-label">Method * </InputLabel>
              )}
              <Select
                labelId="demo-select-basic-label"
                id="demo-select-basic"
                label="Dropdown Label"
                value={method}
                onChange={(e) => setMethodType(e)}
                disabled={readOnlyView || flag == "E"}
                defaultValue={method}
              >
                <MenuItem value="Availability">Availability</MenuItem>
                <MenuItem value="SRS">Schedule Rule Set (SRS)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {method !== null && (
          <Grid container spacing={3} marginTop={3}>
            {toUpperCaseString(method) === "SRS" && (
              <>
                <Grid
                  container
                  spacing={3}
                  marginTop={"0px"}
                  marginLeft={"0px"}
                >
                  <Grid key={"srs"} item xs={2}>
                    <div className={classes.pagesubtitle}>SRS Parameters</div>
                  </Grid>
                  <Grid key={"srs1"} item xs={10}>
                    <NotificationView
                      message={<span> Step 1: Modify at least one parameter and select it’s corresponding critical value.<br/> Step 2: Click “Calculate SRS Values”.<br/>
                      &ensp; &bull; If not all 8 parameters are available, select the checkbox to indicate it is for informational purposes only. <br/> Step 3: Add Comment and Click “Save”.</span>}
                      severity="info"
                      specify="infoEditParent"
                      margin="0px"
                      width="98%"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2}></Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Min Shift Length"
                        onChange={(e) => {setMinShiftLength(e.target.value);
                          setSRSValueChanges(true);
                          setPageValueChanges(true);
                          setIsSRSFieldsValueChanged(true);
                          setModifiedSRSStates(previousState =>{
                            return {...previousState, minShiftLength : e.target.value}
                          })
                        }}
                        value={minShiftLength}
                        type="number"
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={2}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMinShiftCritical);
                           // setSRSValueChanges(true);
                           // setPageValueChanges(true);
                          }
                        }
                          checked={minShiftCritical}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Max Shift Length"
                        onChange={(e) => {setMaxShiftLength(e.target.value);
                        setSRSValueChanges(true);
                        setPageValueChanges(true);
                        setIsSRSFieldsValueChanged(true);
                        setModifiedSRSStates(previousState =>{
                          return {...previousState, maxShiftLength : e.target.value}
                        })
                      }}
                        value={maxShiftLength}
                        type="number"
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={3}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMaxShiftCritical)
                          //setSRSValueChanges(true);
                          //setPageValueChanges(true);
                        }}
                          checked={maxShiftCritical}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2}></Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Min Hours Per Week"
                        onChange={(e) => {setMinHours(e.target.value)
                        setSRSValueChanges(true);
                        setPageValueChanges(true);
                        setIsSRSFieldsValueChanged(true);
                        setModifiedSRSStates(previousState =>{
                          return {...previousState, minHours : e.target.value}
                        })
                      }}
                        value={minHours}
                        type="number"
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={2}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMinHoursCritical)
                          //setSRSValueChanges(true);
                         // setPageValueChanges(true);
                        }}
                          checked={minHoursCritical}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Max Hours Per Week"
                        onChange={(e) => {setMaxHours(e.target.value)
                        setSRSValueChanges(true);
                        setPageValueChanges(true);
                        setIsSRSFieldsValueChanged(true);
                        setModifiedSRSStates(previousState =>{
                          return {...previousState, maxHours : e.target.value}
                        })
                      }}
                        value={maxHours}
                        type="number"
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={3}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMaxHoursCritical)
                          //setSRSValueChanges(true);
                          //setPageValueChanges(true);
                        }}
                          checked={maxHoursCritical}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2}></Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Max Days Per Week"
                        onChange={(e) => {setMaxDay(e.target.value)
                        setSRSValueChanges(true);
                        setPageValueChanges(true);
                        setIsSRSFieldsValueChanged(true);
                        setModifiedSRSStates(previousState =>{
                          return {...previousState, maxDay : e.target.value}
                        })
                      }}
                        value={maxDay}
                        type="number"
                        onKeyPress={(event) => {
                          if (event?.key === ".") {
                            event.preventDefault();
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={2}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMaxDayCritical)
                          //setSRSValueChanges(true);
                          //setPageValueChanges(true);
                        }}
                          checked={maxDayCritical}
                          disabled={
                            
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Max Nights Per Week"
                        onChange={(e) => {setMaxNight(e.target.value)
                        setSRSValueChanges(true);
                        setPageValueChanges(true);
                        setIsSRSFieldsValueChanged(true);
                        setModifiedSRSStates(previousState =>{
                          return {...previousState, maxNight : e.target.value}
                        })
                      }}
                        value={maxNight}
                        type="number"
                        onKeyPress={(event) => {
                          if (event?.key === ".") {
                            event.preventDefault();
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={3}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMaxNightCritical)
                          //setSRSValueChanges(true);
                          //setPageValueChanges(true);
                        }}
                          checked={maxNightCritical}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2}></Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Min Time Between Shifts"
                        onChange={(e) => {setMinTime(e.target.value)
                        setSRSValueChanges(true);
                        setPageValueChanges(true);
                        setIsSRSFieldsValueChanged(true);
                        setModifiedSRSStates(previousState =>{
                          return {...previousState, minTime : e.target.value}
                        })
                      }}
                        value={minTime}
                        type="number"
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={2}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMinTimeCritical)
                          //setSRSValueChanges(true);
                          //setPageValueChanges(true);
                        }}
                          checked={minTimeCritical}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={2.5}>
                    <FormControl style={{ minWidth: "100%" }}>
                      <TextField
                        disabled={
                          readOnlyView ||
                          (flag == "E" && isEditDateValid == false)
                        }
                        inputProps={{ readOnly: readOnlyView }}
                        label="Max Consec Days Per Week"
                        onChange={(e) => {setMaxConsec(e.target.value)
                        setSRSValueChanges(true);
                        setPageValueChanges(true);
                        setIsSRSFieldsValueChanged(true);
                        setModifiedSRSStates(previousState =>{
                          return {...previousState, maxConsec : e.target.value}
                        })
                      }}
                        value={maxConsec}
                        type="number"
                        onKeyPress={(event) => {
                          if (event?.key === ".") {
                            event.preventDefault();
                          }
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid key={"srs"} item xs={3}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {setCritical(e, setMaxConsecCritical)
                          //setSRSValueChanges(true0);
                          //setPageValueChanges(true);
                        }}
                          checked={maxConsecCritical}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false)
                          }
                        />
                      }
                      label="Critical Value"
                      labelPlacement="end"
                    />
                  </Grid>
                  {/* new UI SRS v2 */}
                  <Grid key={"srs"} item xs={2} />
                  <Grid key={"srs"} item xs={8.1}>
                    <FormControlLabel
                      value="top"
                      control={
                        <Checkbox
                          onChange={(e) => {
                            // check if checkbox is checked set non critical to null
                            if(e.target.checked === true) {
                              if(!minShiftCritical) {
                                setMinShiftLength("")
                              }
                              if(!maxShiftCritical) {
                                setMaxShiftLength("")
                              }
                              if(!minHoursCritical) {
                                setMinHours("")
                              }
                              if(!maxHoursCritical) {
                                setMaxHours("")
                              }
                              if(!maxDayCritical) {
                                setMaxDay("")
                              }
                              if(!maxNightCritical) {
                                setMaxNight("")
                              }
                              if(!minTimeCritical) {
                                setMinTime("")
                              }
                              if(!maxConsecCritical) {
                                setMaxConsec("")
                              }
                            }
                            setInformationOnly(e.target.checked);
                          }}
                          checked={isInformationOnly}
                          disabled={
                            readOnlyView ||
                            (flag == "E" && isEditDateValid == false) ||
                            (flag == "E")
                          }
                        />
                      }
                      label="The above values are for information purposes only."
                      labelPlacement="end"
                    />
                  </Grid>
                  <Grid key={"srs"} item xs={1.9}>
                    <Button
                      color="secondary"
                      size="large"
                      style={{
                        minWidth: "95%",

                        minHeight: "100%",
                      }}
                      onClick={getSRSDetails}
                      disabled={
                        readOnlyView ||
                        (flag == "E" && isEditDateValid == false) ||
                        (!isSRSValueChanged ||
                        !((minShiftCritical && !isEmpty(modifiedSRSStates.minShiftLength)) ||
                        (maxShiftCritical && !isEmpty(modifiedSRSStates.maxShiftLength)) ||
                        (minHoursCritical && !isEmpty(modifiedSRSStates.minHours)) ||
                        (maxHoursCritical && !isEmpty(modifiedSRSStates.maxHours)) ||
                        (maxDayCritical && !isEmpty(modifiedSRSStates.maxDay)) ||
                        (maxNightCritical && !isEmpty(modifiedSRSStates.maxNight)) ||
                        (minTimeCritical && !isEmpty(modifiedSRSStates.minTime)) ||
                        (maxConsecCritical && !isEmpty(modifiedSRSStates.maxConsec)))
                      )
                      }
                    >
                      Calculate SRS Values
                    </Button>
                  </Grid>
                 
                </Grid>
              </>
            )}
            {method === "Availability" && (
              <>
                <AddAvailabilityAccomComp />
              </>
            )}
            <Grid key={"detail"} item xs={2} marginTop={3}>
              <div className={classes.pagesubtitle}>Comments</div>
            </Grid>

            <Grid key={"detailView"} item xs={10} marginTop={3}>
              <TextField
                disabled={readOnlyView}
                inputProps={{ readOnly: readOnlyView }}
                multiline={true}
                onChange={(e) => setComments(e.target.value)}
                sx={{ minWidth: "100%" }}
                placeholder="Comments/Details"
                value={comments}
                defaultValue={comments}
              />
            </Grid>

            <Grid key={"stat"} item xs={2} marginTop={3}>
              <div className={classes.pagesubtitle}></div>
            </Grid>
            <Grid key={0} item xs={6} marginTop={-2} marginLeft={-2}>
            
            {kronosMessage != "" && <NotificationView
             message={kronosMessage}
             severity={kronosStatus}
             variant={"standard"}
             specify="infoEditParent"
             />}
            </Grid>
            <Grid key={4} item xs={2} marginBottom={3}>
              {!readOnlyView && (
                <Button
                  color="secondary"
                  size="large"
                  style={{
                    minWidth: "100%",
                   
                  }}
                  onClick={cancelEditing}
                >
                  Cancel
                </Button>
              )}
            </Grid>
            <Grid key={5} item xs={2} marginBottom={3}>
              {readOnlyView && (
                <Button
                  sx={{ minWidth: "100%" }}
                  color="primary"
                  size="large"
                  onClick={makeEditable}
                  disabled={
                    endDate !== null &&
                    moment(endDate).isBefore(moment(), "day")
                  }
                >
                  Edit
                </Button>
              )}{" "}
              {!readOnlyView && (
                <Button
                  color="primary"
                  size="large"
                  style={{
                    minWidth: "100%",
                   
                  }}
                  onClick={saveData}
                  disabled={ method != "SRS" ? false : (flag == "E" ) ? ((isPageValueChanged == null ? false : isSRSValueChanged )) : ((isPageValueChanged == null || isPageValueChanged == false) ? true : isSRSValueChanged) }
                  >
                  Save
                </Button>
              )}
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default AddEditAccomodations;
